// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__MGmIq","row":"ProcedureTreatmentSummary_row__7HERC"};